import React from "react"
import styled from "@emotion/styled"
import ButtonLink from "../global/ButtonLink"

const Outer = styled.section`
  display: grid;
  grid-template-columns:
    minmax(32px, auto) minmax(auto, ${props => props.theme.maxWidth})
    minmax(32px, auto);
  padding: 160px 0;
  background: ${props =>
    props.backgroundColorOverride
      ? props.backgroundColorOverride
      : "transparent"};
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    grid-template-columns: 24px auto 24px;
  }
`
const Inner = styled.div`
  grid-column: 2;
  text-align: center;
  display: grid;
  gap: 64px;
`
const Title = styled.h1``
const TextContainer = styled.div`
  max-width: 640px;
  margin: 0 auto;
  p {
    margin: 0 auto;
    max-width: 480px;
  }
`
const PostCardContainer = styled.div`
  display: grid;
  gap: 32px;
  max-width: 640px;
  margin: 0 auto;
  p {
    margin: 0 auto;
    max-width: 480px;
  }
`
const CardGrid = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 1fr;
  gap: 32px;
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    grid-auto-flow: row;
  }
`
const ButtonContainer = styled.div`
  margin: 0 auto;
`

export default function CardFeature({
  title,
  content,
  postContent,
  backgroundColorOverride,
  cards,
  buttonText,
  buttonLink,
}) {
  return (
    <Outer backgroundColorOverride={backgroundColorOverride}>
      <Inner>
        {(title || content) && (
          <TextContainer>
            {title && <Title>{title}</Title>}
            {content && <p>{content}</p>}
          </TextContainer>
        )}
        <CardGrid>{cards}</CardGrid>
        <PostCardContainer>
          {postContent && <p>{postContent}</p>}
          <ButtonContainer>
            <ButtonLink
              to={buttonLink}
              backgroundColorOverride={props => props.theme.primary}
            >
              {buttonText}
            </ButtonLink>
          </ButtonContainer>
        </PostCardContainer>
      </Inner>
    </Outer>
  )
}
